import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { NavService } from '../services/nav.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FscHomeResolved, FscHome } from '../model/fsc.home.model';
import { CommonService } from '../services/common.service';
import { FclLoginService } from '../services/fcllogin.service';
import { OktaAuthService } from '@okta/okta-angular';
import { FscAuthorizedMenusResolver } from '../model/nav-item';

@Injectable({
    providedIn: 'root'
})
export class HomeServiceResolver implements Resolve<Observable<FscAuthorizedMenusResolver>> {
    constructor(private navService: NavService) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<FscAuthorizedMenusResolver> {
        return this.navService.getAuthorizedMenus().pipe(
        // return this.navService.getFscAuthorizedMenus().pipe(
            map(fscAuthorizedMenusResponse => ({ fscAuthorizedMenusResponse, error: null })),
            catchError(errorResponse => {
                // const message = `Retrieval error: ${error}`;
                // console.error(message);
                return of({ fscAuthorizedMenusResponse: null, error: errorResponse });
            })
        );
        // return this.navService.getUserModules();
    }
}
